module.exports = __webpack_public_path__ + "static/media/solution-of-banner.2febed9f.jpg";